import { render, staticRenderFns } from "./CartService.vue?vue&type=template&id=2b18ca16"
import script from "./CartService.vue?vue&type=script&lang=js"
export * from "./CartService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b18ca16')) {
      api.createRecord('2b18ca16', component.options)
    } else {
      api.reload('2b18ca16', component.options)
    }
    module.hot.accept("./CartService.vue?vue&type=template&id=2b18ca16", function () {
      api.rerender('2b18ca16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CartService.vue"
export default component.exports